import content from './jsonParsers/content.json'
import { fixedEls } from './helper';


const LandingSet = {
    //first part title
    //TODO WORK ON THIS
    title1: {
        ...content.Opening[0]
    },
    landingCopy: {
        ...content.Opening[1]
    },
    ...fixedEls
};

export default LandingSet;
